module.exports = {
      id: "logos:certsy-logo-usage",
      viewBox: "0 0 118 35",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#logos:certsy-logo-usage",
      toString: function () {
        return this.url;
      }
    }